export class ConditionUnitRangeModel {
    conditionUnitRangeId: number;
    conditionUnitRangeSystemTypeId: number;
    genderTypeId: number;
    minValue: string;
    maxValue: string;
    minAge: number;
    maxAge: number;
    secondMinValue: string;
    secondMaxValue: string;
}